// extracted by mini-css-extract-plugin
export default {"Machines":"Machines_Machines__9VLM9"};